import React from "react";

const Row = (props) => {
  return <div style={{ ...styles.row, ...props.style }}>{props.children}</div>;
};

const styles = {
  row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
};

export default Row;
